import { Component, HostListener, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-pair-bar-chart',
  templateUrl: './pair-bar-chart.component.html',
  styleUrls: ['./pair-bar-chart.component.css']
})
export class PairBarChartComponent implements OnInit, OnChanges {

  @Input() chartData:any
  @HostListener('window:resize', ['$event'])
  onResize() {
    setTimeout(() => {
      this._plotBar();
    }, 1);
  }
  chartOption:any;

  constructor() { }

  ngOnChanges(): void {
    if (this.chartData?.data[0].length) {
      this._plotBar();
    }
  }

  ngOnInit(): void {
   }

  _plotBar(){
    
   let i=0;
    this.chartOption = {
      tooltip: {
        trigger: 'axis',
      },
      color:['#71A2BE', '#9DD0ED', '#8CA4D2', '#9B79BC', '#6155AC'],
      legend: {
        data: this.chartData?.legend,
        top: "0%"
      },
      xAxis: [
        {
          type: 'category',
          data: this.chartData?.xAxisLabel,
          axisLabel: {
            interval: 0,
            rotate: 45,
            fontSize: 11,
          },
          axisPointer: {
            type: 'shadow'
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Alerts',
          min: 0,
          interval: Math.ceil(Math.max(...this.chartData?.data[0]) / 7),
        },
      ],
      series: this.chartData.legend.map(
        (name) =>{
          return {
              name: name,
              type: 'bar',
              barWidth: '20%',
              data: this.chartData.data[i++]
          }
        }
      )
    };
  }

}
